/**
 * Migrações de schema da fila persistida.
 */

import type { QueueItem } from '../queue';

const LS_V1 = 'GOMARKE_QUEUE_V1';
const LS_V2 = 'GOMARKE_QUEUE_V2';
export const QUEUE_SCHEMA_VERSION = 2;

export function migrateQueueStorageV1ToV2(): void {
  if (typeof window === 'undefined') return;
  try {
    const v1 = window.localStorage.getItem(LS_V1);
    if (v1 && !window.localStorage.getItem(LS_V2)) {
      window.localStorage.setItem(LS_V2, v1);
    }
  } catch {
    // ignore
  }
}

export function migrateQueueItems(items: QueueItem[]): QueueItem[] {
  return items.map(i => ({
    ...i,
    sessionSequence: i.sessionSequence ?? 0,
    status: i.status ?? 'queued',
    occurredAt: i.occurredAt ?? i.createdAt,
  }));
}
